export enum PalletType {
    existing = 'existing',
    new = 'new',
}